// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2RV-w","icon":"style_icon__1RSoW"};